import { render, staticRenderFns } from "./footer_nav.vue?vue&type=template&id=33345ae4&scoped=true"
import script from "./footer_nav.vue?vue&type=script&lang=js"
export * from "./footer_nav.vue?vue&type=script&lang=js"
import style0 from "./footer_nav.vue?vue&type=style&index=0&id=33345ae4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33345ae4",
  null
  
)

export default component.exports